import { useEffect, useState } from "react";
import Style from "css/repair_css/repair_d.module.css";
import ConfirmDialog from "components/confirm_dialog";
import OnlyConfirmDialog from "components/onlyConfirm_dialog";
import RequestDialog from "./request_dialog";
import MatchingDetailDialog from "./matching_detail_dialog";
import RatingDialog from "./rating_dialog";
import { useNavigate } from "react-router-dom";
import {
  // acceptMatching, // [DEPRECATED] 즉시 매칭 → 신청-선택 모델로 대체
  deleteMatch,
  giveRating,
} from "firebase_/firebase_function/matching";
// import { doneMatchSend } from "api/post/post_matching"; // [DEPRECATED] 즉시 매칭 시 사용
import { applyMatchApi, getApplicantsApi } from "api/match";

const DetailPageButton = ({ userData, repair, docId, isMobile }) => {
  const navigate = useNavigate();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [ratingDialog, setRatingDialog] = useState(false);
  const [matchingDialog, setMatchingDialog] = useState(false);
  const [matchingDetailDialog, setMatchingDetailDialog] = useState(false);
  const [onlyConfirmModal, setOnlyConfirmModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  /// ✅ 확인모달 관련
  const [onlyConfirmDialog, setOnlyConfirmDialog] = useState(false);
  const [message, setMessage] = useState("");

  /// ✅ 포인트 결제 화면 이동 관련
  const [pointCheckDialog, setPointCheckDialog] = useState(false);

  /// ✅ 신청-선택 모델: 내가 이미 신청했는지
  const [myApplied, setMyApplied] = useState(false);

  useEffect(() => {
    // 수리기사 + 매칭 대기 요청이면 내 신청 여부 확인
    if (
      userData?.userType === "수리기사" &&
      repair &&
      String(repair.status) === "0" &&
      userData.id !== repair?.id
    ) {
      (async () => {
        try {
          const list = await getApplicantsApi(docId);
          setMyApplied(list.some((a) => a.expertId === userData.id));
        } catch {}
      })();
    }
  }, [docId, repair, userData]);

  /// ✅ 요청 삭제 함수
  const pressedDeleteMatch = async () => {
    const result = await deleteMatch(docId);

    if (result) {
      navigate("/matching");
    } else {
      setOnlyConfirmModal(true);
      setModalMessage("요청삭제에 실패했습니다.");
    }
  };

  /// [DEPRECATED] 즉시 매칭 — 신청-선택 모델로 대체
  // const pressedAcceptMetching = async () => {
  //   const result = await acceptMatching(docId, userData.id, userData.name);
  //   if (result.status === "point") {
  //     setPointCheckDialog(true);
  //     return;
  //   }
  //   doneMatchSend(repair, userData.name);
  //   setMessage(result.message);
  //   setOnlyConfirmDialog(true);
  // };

  /// ✅ 신청하기 — 농가가 선택하면 그때 100P 차감
  const pressedApply = async () => {
    try {
      const result = await applyMatchApi({
        matchDocId: docId,
        expertId: userData.id,
        expertName: userData.name,
      });
      if (result?.status === "point") {
        setPointCheckDialog(true);
        return;
      }
      if (result?.status === "duplicated") {
        setMyApplied(true);
        setMessage("이미 신청한 요청입니다.");
        setOnlyConfirmDialog(true);
        return;
      }
      if (result?.success) {
        setMyApplied(true);
        setMessage("신청이 완료되었습니다.\n농가가 회원님을 선택하면 매칭됩니다.");
      } else {
        setMessage(result?.message || "신청에 실패했습니다.");
      }
      setOnlyConfirmDialog(true);
    } catch (e) {
      setMessage("신청에 실패했습니다. 잠시 후 다시 시도해주세요.");
      setOnlyConfirmDialog(true);
    }
  };
  /// ✅ 별점 주기 함수
  const pressedRating = async (rating) => {
    setRatingDialog(false);

    console.log("ratinmg", rating);
    if (rating === 0) {
      setOnlyConfirmDialog(true);
      setMessage("별점을 선택해주세요.");
      return;
    }

    const result = await giveRating(
      docId,
      repair?.expertId,
      userData.id,
      rating
    );

    if (result == "duplicated") {
      setOnlyConfirmDialog(true);
      setMessage("이미 별점이 부여된 요청입니다.");
      return;
    }

    if (result) {
      setOnlyConfirmDialog(true);
      setMessage("요청이 처리되었습니다.");
    } else {
      setOnlyConfirmDialog(true);
      setMessage("요청처리에 실패했습니다.");
    }
  };

  return (
    <>
      {repair && userData && (
        <>
          {userData.id === repair?.id ? (
            <>
              {repair?.status > 0 ? (
                <div
                  onClick={() => {
                    if (repair?.rating === false) {
                      setRatingDialog(true);
                    }
                  }}
                  className={`f16_FFFFFF_W500`}
                  style={{
                    width: "100%",
                    display: repair?.rating ? "none" : "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "18px",
                    backgroundColor: "#2e4a24",
                    borderRadius: "8px",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  별점주기
                </div>
              ) : (
                <div
                  className={Style.row_center}
                  style={{ gap: "8px", width: "100%" }}
                >
                  <button
                    type="button"
                    onClick={() => {
                      if (!isMobile) {
                        setIsDialogOpen(true);
                      } else {
                        navigate(`/fix_request/${docId}`);
                      }
                    }}
                    className={Style.center}
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      height: "50px",
                      backgroundColor: "#2E4A24",
                      color: "#FFFFFF",
                    }}
                  >
                    수정하기
                  </button>
                  <button
                    type="button"
                    className={Style.center}
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      border: "1px solid #c3c9c1",
                      backgroundColor: "#FFFFFF",
                      height: "50px",
                      color: "#2E4A24",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setDeleteModal(true);
                    }}
                  >
                    삭제하기
                  </button>
                </div>
              )}
            </>
          ) : (
            <>
              <div
                className={Style.row_center}
                style={{ gap: "8px", width: "100%" }}
              >
                {repair?.status !== 0 && userData.id === repair?.expertId ? (
                  <>
                    <button
                      type="button"
                      className={Style.center}
                      style={{
                        width: "100%",
                        borderRadius: "8px",
                        height: "50px",
                        backgroundColor: "#2E4A24",
                        color: "#FFFFFF",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setMatchingDetailDialog(true);
                      }}
                    >
                      상세정보
                    </button>
                  </>
                ) : (
                  <>
                    {userData.userType === "수리기사" && (
                      <button
                        type="button"
                        className={Style.center}
                        disabled={myApplied}
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                          height: "50px",
                          backgroundColor: myApplied ? "#E5E7EB" : "#2E4A24",
                          color: myApplied ? "#6B7280" : "#FFFFFF",
                          cursor: myApplied ? "default" : "pointer",
                        }}
                        onClick={() => {
                          if (!myApplied) setMatchingDialog(true);
                        }}
                      >
                        {myApplied
                          ? "신청 완료 · 농가 선택 대기 중"
                          : "신청하기"}
                      </button>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}
      <ConfirmDialog
        open={deleteModal}
        onClose={() => setDeleteModal(false)}
        onConfirm={() => {
          pressedDeleteMatch();
          setDeleteModal(false);
        }}
        message={"요청을 삭제 하시겠습니까?"}
      />
      <ConfirmDialog
        open={pointCheckDialog}
        onClose={() => setPointCheckDialog(false)}
        onConfirm={() => {
          setDeleteModal(false);
          navigate("/addpoint");
        }}
        title={"포인트가 부족합니다."}
        message={"결제 페이지로 이동하시겠습니까?"}
      />
      <ConfirmDialog
        open={matchingDialog}
        onClose={() => setMatchingDialog(false)}
        onConfirm={() => {
          pressedApply();
          setMatchingDialog(false);
        }}
        title={"이 요청에 신청하시겠습니까?"}
        message={"농가가 회원님을 선택하면 100 포인트가 차감됩니다."}
      />
      <OnlyConfirmDialog
        open={onlyConfirmModal}
        onClose={() => {
          setOnlyConfirmModal(false);
        }}
        message={modalMessage}
      />
      <RequestDialog
        open={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
        isEdit={true}
        data={repair}
      />
      <MatchingDetailDialog
        open={matchingDetailDialog}
        data={repair}
        onClose={() => {
          setMatchingDetailDialog(false);
        }}
      />
      <RatingDialog
        open={ratingDialog}
        onClose={() => setRatingDialog(false)}
        onConfirm={pressedRating}
      />
      <OnlyConfirmDialog
        open={onlyConfirmDialog}
        onClose={() => {
          setOnlyConfirmDialog(false);
          window.location.reload();
        }}
        message={message}
      />
    </>
  );
};

export default DetailPageButton;
